import React, { useEffect, useState } from 'react';
import { CardCvcElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js';
import { Checkbox } from '@progress/kendo-react-inputs';
import countriesList from '../Shared/CountriesList/CountriesList.json';
import { ComboBox } from '@progress/kendo-react-dropdowns';
import AcceptedCardTypes from './AcceptedCardTypes';
import { RadioButton } from '@progress/kendo-react-inputs';
import { Tooltip } from '@progress/kendo-react-tooltip';

const ELEMENT_OPTIONS = {
    style: {
        base: {
            fontSize: '15px',
            color: '#172b4d',
             fontWeight: 600,
             fontFamily: '"SF Pro Display", sans-serif',
            '::placeholder': {
                color: '#3446634d',
            },
        },
        invalid: {
            color: '#9e2146',
        },
    }
};

const ELEMENT_CARD_OPTIONS = {
    style: {
        base: {
            fontSize: '15px',
            color: '#172b4d',
             fontWeight: 600,
             fontFamily: '"SF Pro Display", sans-serif',
            '::placeholder': {
                color: 'transparent',
            },
        },
        invalid: {
            color: '#9e2146',
        },
    }
};

function NewCardForm({ onChange, errors = {} }) {

    const [complete, setComplete] = useState(false);
    const [cardNumberError, setCardNumberError] = useState(null);
    const [cardExpiryError, setCardExpiryError] = useState(null);
    const [cardCvcError, setCardCvcError] = useState(null);

    useEffect(
        () => {
            onChange({
                valid: (
                    complete &&
                    !cardNumberError &&
                    !cardExpiryError &&
                    !cardCvcError
                )
            })
        },
        [ complete, cardNumberError, cardExpiryError, cardCvcError ]
    )

    return (
        <form className='container-fluid' onSubmit={e => e.preventDefault()}>
            <div className='d-flex mt-2 align-center justify-content-between'>
                {/* <div>
                <RadioButton
                  defaultChecked
                  label='Credit Card'
                  className='me-1'
                   />
                    </div> */}
                    
                <div>
                    <AcceptedCardTypes
                        className="my-2" />
                </div>
                </div>
                <div className='row mt-2'>
                <div className='col-12 mt-2'>
                    <label className='form-label'>Card Number</label>
                    <CardNumberElement
                        options={{
                            ...ELEMENT_CARD_OPTIONS,
                            showIcon: true
                        }}
                        onChange={(event) => {                            
                            if (event.empty) {
                                setCardNumberError("Please enter the card number")
                            } else if (event.error) {
                                setCardNumberError(event.error.message);
                            } else {
                                setCardNumberError(null);
                            }
                            setComplete(event.complete)
                        }} />
                    <span className='text-danger'>
                        { cardNumberError || errors.cardNumberError }
                    </span>
                </div>
                <div className='col-6 mt-2'>
                    <label className='form-label'>Expiration Date</label>
                    <CardExpiryElement
                        options={ELEMENT_OPTIONS}
                        onChange={(event) => {
                            if (event.empty) {
                                setCardExpiryError("Please enter Expiration Date")
                            } else if (event.error) {
                                if (
                                    event.error.message === "Your card's expiration date is in the past." ||
                                    event.error.message === "Your card's expiration year is in the past."    
                                ) {
                                    setCardExpiryError("Card expired");
                                } else if (
                                    event.error.message === "Your card's expiration date is incomplete."
                                ) {
                                    setCardExpiryError("Incomplete expiration date");
                                } else {
                                    setCardExpiryError(event.error.message);
                                }
                            } else {
                                setCardExpiryError(null);
                            }
                            setComplete(event.complete)
                        }} />
                    <span className='text-danger'>
                        { cardExpiryError || errors.cardExpiryError }
                    </span>
                </div>
                <div className='col-6 mt-2'>
                    
                        <label className='form-label'>Security Code</label>
                   <div className='row pl-10'>
                        <div className='col-10' style={{ paddingRight: 0 }}>
                            <CardCvcElement
                                className='security-code-field'
                                options={ELEMENT_OPTIONS}
                                onChange={(event) => {
                                    if (event.empty) {
                                        setCardCvcError("Please enter the security code")
                                    } else if (event.error) {
                                        if (event.error.message === "Your card's security code is incomplete.") {
                                            setCardCvcError("Incomplete security code");
                                        } else {
                                            setCardCvcError(event.error.message);
                                        }
                                    } else {
                                        setCardCvcError(null);
                                    }
                                    setComplete(event.complete)
                                }} />
                        </div>
                        <div className='col-2 security-code-info d-flex align-items-center'>
                        <span className='input-group-text'>
                            <Tooltip position='right' anchorElement='target'>
                                <i
                                    title='3 or 4 digits at the back of your card'
                                    className='fa-regular fa-info-circle'/>
                            </Tooltip>
                            </span>
                        </div>
                    </div>
                    <span className='text-danger'>{cardCvcError || errors.cardCvcError}</span>
                </div>
            </div>
        </form>
    )
};

export default NewCardForm;